module.exports = __webpack_public_path__ + "static/media/embs_profil.9c4f6ae4.png";